import styled from '@emotion/styled';
import { ReactNode } from 'react';
import * as React from 'react';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

type BadgeProps = {
  children: ReactNode;
  isShow: boolean;
  hasCount?: boolean;
  top?: string;
  right?: string;
  count?: number;
  style?: React.CSSProperties;
};

export const StyledBadge = styled.div((props: BadgeProps) =>
  mq({
    display: 'flex',
    placeSelf: 'center',
    position: 'relative',
    '&::before': props.isShow && {
      zIndex: 1,
      content: props.hasCount ? `"${props.count}"` : '""',
      fontSize: '10px',
      color: defaultTheme.color.white,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: props.top,
      right: props.right,
      width: props.hasCount ? '24px' : '12px',
      height: props.hasCount ? '24px' : '12px',
      borderRadius: defaultTheme.border.radius.circle,
      backgroundColor: defaultTheme.background.primary,
    },
  }),
);

const Badge: React.FC<BadgeProps> = props => {
  return <StyledBadge {...props} />;
};

export default Badge;
